import { cookieService } from './cookie-service';
import { queryParamService } from "./query-param-service";

const partnerId = "switchcraft";

const getAffiliateReferralCookies = () => {
  const affiliateReferralPartnerId = cookieService.get('partnerId');
  const affiliateReferralId = cookieService.get('affiliateId');

  const affiliateReferralCustomerIdClickRef
    = queryParamService.get("clickref")
    || cookieService.get("clickref");

  const affiliateReferralCustomerId = affiliateReferralCustomerIdClickRef
    || cookieService.get("customerId");

  if (affiliateReferralCustomerId && affiliateReferralPartnerId) {
    return {
      affiliateReferralPartnerId,
      affiliateReferralCustomerId,
      ...(affiliateReferralId ? { affiliateReferralId } : {})
    }
  }
  return undefined;
};

const getReferrerTokenInput = () => {

  const referrerToken = cookieService.get('referral-token');
  if (!referrerToken) {
    return;
  }
  return { referrerToken };
};

const setupCallApi = (apiurl) => (url, method = "GET", body) => {
  return fetch(`${apiurl}${url}`, {
    headers: {
      'content-type': 'application/json',
    },
    method,
    ...(
      body
        ? {
          body: JSON.stringify(body)
        }
        : {}
    ),
    mode: 'cors'
  })
  .then(resp => resp.json());
};

let callApi = null;

const SSID_KEY = 'scid';

export const apiService = {
  setBaseUrl: (apiurl) => {
    callApi = setupCallApi(apiurl);
  },

  getSignUp: async () => {
    const affiliateReferralCustomerId
      = queryParamService.get("clickref")
       || cookieService.get("clickref");

    const ssid = cookieService.get(SSID_KEY);

    const query = [
      `id=${ssid}`,
      affiliateReferralCustomerId
        && `affiliateReferralCustomerId=${
          affiliateReferralCustomerId
        }`
    ].filter(Boolean).join("&");

    const energySignUp = await callApi(`/sign-up?${query}`)
      .then((signUpResponse) => signUpResponse.energySignUp);
    cookieService.set(SSID_KEY, energySignUp.id, null, '/');
    return energySignUp;
  },

  getAddressForSignUp: async (energySignUp) => {
    const { addressId, manualAddress } = energySignUp.orderRequest || {};
    if (manualAddress) {
      return manualAddress;
    }
    if (!addressId) {
      return;
    }
    const addressResponse = await callApi(`/address/${addressId}`);
    return addressResponse && addressResponse.address;
  },

  getAddresses: (postcode) => callApi(`/addresses?postcode=${postcode}`),

  saveManualAddressAndEmailPage: async(
    profileId,
    address,
    email,
    acceptedMarketingConsent
  ) => {
    const affiliateReferral = getAffiliateReferralCookies();
    const manualData = {
      id: profileId,
      manualAddress: address,
      email: email,
      hasAcceptedMarketingConsent: acceptedMarketingConsent,
      hasAcceptedTermsAndConditions: true,
      partnerId,
      ...affiliateReferral,
      ...getReferrerTokenInput()
    };
    const signUp = await callApi(
      "/save-manual-address-email",
      "POST",
      manualData
    );
    cookieService.set(SSID_KEY, signUp.id, null, '/');
    return signUp;
  },

  saveAddressAndEmailPage: async (
    profileId,
    address,
    email,
    acceptedMarketingConsent
  ) => {
    const affiliateReferral = getAffiliateReferralCookies();
    const data = {
      id: profileId,
      addressId: address.id,
      email: email,
      hasAcceptedMarketingConsent: acceptedMarketingConsent,
      hasAcceptedTermsAndConditions: true,
      partnerId,
      ...affiliateReferral,
      ...getReferrerTokenInput()
    };
    const signUp = await callApi(
      "/save-address-email",
      "POST",
      data
    );
    cookieService.set(SSID_KEY, signUp.id, null, '/');
    return signUp;
  },

  validatePostcode: (postcode) => callApi(`/validate-postcode?postcode=${postcode}`),

  hasExistingAutoSwitch: (signUpId) => callApi(`/has-existing-auto-switch?id=${signUpId}`),

};
